import type { IconSvgObject } from './types';

const TableRoundIcon: IconSvgObject = [
  ["ellipse", { cx: "12", cy: "6.5", rx: "10", ry: "3", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 20.5H9L9.77208 18.1838C9.90819 17.7754 10.2903 17.5 10.7208 17.5H13.2792C13.7097 17.5 14.0918 17.7754 14.2279 18.1838L15 20.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 17.5V9.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default TableRoundIcon;
